export enum ElectricityType {
    "", "EBEM Groen Variabel" = 60454027, "EBEM Groen Dyn@mic" = 63353789, "EBEM Groen B@sic +" = 60472062, "EBEM Groen B@il" = 56802816
}